import { CRMPageBody } from "../components/marketo";

const CRMPage = () => {
  return <CRMPageBody />;
};

export default CRMPage;
